import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import BulkUpload from "../pages/CertificateIssuer/BulkUpload/BulkUpload";
import CertificateList from "../pages/CertificateIssuer/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/CertificateIssuer/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/CertificateIssuer/Certificate/ViewCertificate/ViewCertificate";
import Dashboard from "../pages/CertificateIssuer/Dashboard/Dashboard";
import Profile from "../pages/CertificateIssuer/Profile/Profile";
import UserActivityLogs from "../pages/CertificateIssuer/Profile/UserActivityLogs/UserActivityLogs";

var CertificateIssuerRoutes = [
    {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "Profile",
    element: <Profile/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "my-activities",
    name: "Activity Logs",
    element: <UserActivityLogs/>,
    layout: "issuer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default CertificateIssuerRoutes;
